import React from "react";
import { useMessageContext } from "stream-chat-react";
import { Gift } from "@phosphor-icons/react";
import { frameStyle } from "../lib/badgeFrames";

/**
 * LiveChatMessage — compact chat line for live streams. Top-badge creators
 * (1K Club / Crowd Favorite / 10K Legend) get a golden frame around their
 * comments and gifts; everyone else renders as a plain glass chip.
 */
export default function LiveChatMessage() {
  const { message } = useMessageContext();
  if (!message || message.type === "deleted") return null;
  const user = message.user || {};
  const fs = frameStyle(user.badge_frame);
  const isGift = !!message.gift_id;
  const name = user.name || user.id || "dancer";
  const initial = (name[0] || "?").toUpperCase();

  return (
    <div
      className={`mx-2 my-1 flex items-start gap-2 rounded-2xl px-2.5 py-1.5 border transition-colors ${
        fs ? `${fs.bg} ${fs.border} ${fs.glow}` : "bg-white/5 border-white/5"
      } ${isGift ? "items-center" : ""}`}
      data-testid={`live-msg-${message.id}`}
      data-badge-frame={user.badge_frame || ""}
    >
      <div className={`w-7 h-7 rounded-full overflow-hidden flex-shrink-0 bg-gradient-to-br from-papaya to-sea flex items-center justify-center text-ink text-xs font-black ${fs ? fs.ring : ""}`}>
        {user.image ? <img src={user.image} alt="" className="w-full h-full object-cover" /> : initial}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1 flex-wrap">
          <span className={`text-[11px] font-black truncate max-w-[140px] ${fs ? fs.text : "text-papaya"}`}>{name}</span>
          {fs && (
            <span className={`text-[8px] tracking-[0.15em] uppercase font-black ${fs.text}`} data-testid="live-msg-badge">
              {user.badge_emoji} {user.badge_label || fs.label}
            </span>
          )}
        </div>
        {isGift ? (
          <div className={`mt-0.5 inline-flex items-center gap-1.5 rounded-xl px-2 py-1 border ${fs ? `${fs.border} bg-black/30` : "border-white/10 bg-white/5"}`} data-testid="live-msg-gift">
            <Gift size={12} weight="fill" className={fs ? fs.text : "text-papaya"} />
            <span className="text-base leading-none">{message.gift_emoji}</span>
            <span className="text-cream text-xs font-bold">{message.gift_label}</span>
            {message.waves_spent ? <span className={`text-[9px] font-black ${fs ? fs.text : "text-papaya"}`}>{message.waves_spent}W</span> : null}
          </div>
        ) : (
          <p className="text-cream text-sm leading-snug break-words">{message.text}</p>
        )}
      </div>
    </div>
  );
}
